import { TTrackingImpressionSection } from '.'
import { ELanguage } from '../Utils/constants'
import { TQuery } from './type'

type TGetJobYouWillLoveP = {
    baseUrl: string
    langCode: ELanguage
    query?: TQuery
    smartNaviVersion: string
    formDataExcludeJobIds?: FormData
}

export const getJobYouWillLove = async ({
    baseUrl,
    langCode,
    query,
    smartNaviVersion,
    formDataExcludeJobIds
}: TGetJobYouWillLoveP) => {
    const encodeQuery = query
        ? `?${new URLSearchParams({
              ...query,
              t: String(Date.now())
          }).toString()}&${new URLSearchParams(formDataExcludeJobIds as any).toString()}`
        : ''

    const urlApi = `${baseUrl}/smartnavi/${smartNaviVersion}/jobs${encodeQuery}`

    const res = await fetch(urlApi, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Accept-Language': langCode,
            'Content-Type': 'application/json'
        }
    })
        .then((res) => res.json())
        .catch((error) => console.error(error))

    if (res?.total > 0) {
        return {
            data: res,
            error: ''
        }
    } else {
        return {
            data: {
                jobs: [],
                source: ''
            },
            error: res?.error
        }
    }
}

type TSpecialJobP = {
    baseUrl: string
    accessToken: string
    jobs: any[]
}

const STATUS_CODE = 200

export const getSpecialJob = async ({ baseUrl, accessToken, jobs }: TSpecialJobP) => {
    const emptySpecialJob = jobs.map((item) => {
        return {
            ...item,
            isSaved: false,
            isApplied: false,
            isBlackList: false,
            isMatching: false,
            redirectTo: ''
        }
    })
    if (!accessToken) {
        return {
            data: emptySpecialJob,
            error: ''
        }
    }

    const urlApi = `${baseUrl}/api-gateway/v1.0/special-jobs`
    const ids = jobs.map((item: any) => item.jobId)

    const res = await fetch(urlApi, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        },
        body: JSON.stringify({ jobId: ids })
    })
        .then((res) => res.json())
        .catch((error) => console.error(error))

    if (res?.status?.code === STATUS_CODE) {
        return {
            data: jobs.map((item, idx) => {
                return {
                    ...item,
                    isMatching: res.data[idx].attributes?.matching,
                    isSaved: res.data[idx].attributes?.saved,
                    isApplied: res.data[idx].attributes?.applied,
                    isBlackList: res.data[idx].attributes?.userBlackList,
                    redirectTo: res.data[idx].attributes?.redirectTo,
                    jobInvitation: res.data[idx].attributes?.jobInvitation ?? { jobInvitationId: 0, status: 0 }
                }
            }),
            error: ''
        }
    } else {
        return {
            data: emptySpecialJob,
            error: res?.error
        }
    }
}

export type TTrackImpressionParam = {
    baseMsUrl: string
    langCode: ELanguage
    body: {
        section: TTrackingImpressionSection
        jobRecommend: number[]
        version: string
        clientIP: string
        jobID: number
        userID: string
    }
}

export const trackImpression = async (params: TTrackImpressionParam) => {
    try {
        const { baseMsUrl, langCode, body } = params

        const url = `${baseMsUrl}/smartnavi/v1/tracking-impression`

        const rawResponse = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': langCode
            },
            body: JSON.stringify(body)
        })

        await rawResponse.json()
    } catch (ex) {
        console.error(ex)
    }
}
